const body = document.querySelector("body");
const banner = document.querySelector("section.hero");
const menuTrigger = document.querySelector("button.menu-toggle");
const logo = document.querySelector(".header__container__logo");

function updateMenuTrigger() {
  const bannerBottomPosition = banner ? banner.offsetHeight : 400;
  let scrollPosition = window.pageYOffset;

  // console.log(bannerBottomPosition, scrollPosition);

  if (menuTrigger) {
    if (scrollPosition > bannerBottomPosition) {
      body.classList.add("sticky-menu");
      logo.classList.add("hide-logo");
    } else {
      body.classList.remove("sticky-menu");
      logo.classList.remove("hide-logo");
    }
  }
}

// Throttle function to improve performance
function throttle(fn, wait) {
  let lastTime = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastTime >= wait) {
      fn(...args);
      lastTime = now;
    }
  };
}

["resize", "scroll"].forEach((event) => {
  window.addEventListener(event, throttle(updateMenuTrigger, 20));
});
